export default "__VITE_ASSET__BuYwP4xX__"